import './App.css';
import {useFetchProgram} from "./Hooks/useFetchProgram";
import {Day} from "./Components/Day";
import {Col, Row, Spinner} from "react-bootstrap";

function App() {
    const {program, loading} = useFetchProgram();

    if (loading) {
        return <Row className="justify-content-md-center">
            <Col xs lg="2">
                <Spinner animation="grow" variant="dark" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </Col>
        </Row>
    }

    return (
        <div className="App">
            {Object.keys(program).map((day) => (<Day key={day} day={day} sessions={program[day]}/>))}
        </div>
    );
}

export default App;
